/**
 * 🍷 Wijnen Page Functionality
 * Handles "Add to My Wines" feature for logged-in customers
 */

class WijnenPage {
  constructor() {
    this.init();
  }

  init() {
    // Check if user is logged in
    this.isLoggedIn = document.body.classList.contains('customer-logged-in');
    
    // Add page class for styling
    document.body.classList.add('wijnen-page');
    
    // Apply tier styling based on content
    this.applyTierStyling();
    
    // Initialize carousel functionality
    this.initCarousel();
    
    // Initialize Add to My Wines buttons
    this.initAddToWinesButtons();
  }

  applyTierStyling() {
    console.log('🏷️ Starting tier styling...');
    // Find all wine cards and apply tier styling based on content
    const wineCards = document.querySelectorAll('.multicolumn .multicolumn-card');
    
    console.log(`🍷 Found ${wineCards.length} wine cards`);
    
    wineCards.forEach((card, index) => {
      console.log(`🔍 Processing card ${index + 1}...`);
      const textContent = card.querySelector('.multicolumn-card__info');
      if (!textContent) {
        console.log(`❌ No text content found for card ${index + 1}`);
        return;
      }
      
      const firstP = textContent.querySelector('p:first-child');
      if (!firstP) {
        console.log(`❌ No first paragraph found for card ${index + 1}`);
        return;
      }
      
      const tierText = firstP.textContent;
      
      // Remove any existing tier classes
      firstP.classList.remove('tier-all', 'tier-2plus', 'tier-3plus', 'tier-baas');
      
      // Add tier class and badge based on content
      let badgeText = '';
      let badgeClass = '';
      
      console.log(`🔍 Tier text for card ${index + 1}: "${tierText}"`);
      
      if (tierText.includes('De Ontdekker • De Genieter • De Fijnproever • De Baas')) {
        // Wijn 1: Voor alle pakketten
        firstP.classList.add('tier-label', 'tier-all');
        card.classList.add('tier-all');
        badgeText = 'Alle Pakketten';
        badgeClass = 'badge-all';
        console.log(`✅ Card ${index + 1}: Alle pakketten`);
      } else if (tierText.includes('De Genieter • De Fijnproever • De Baas')) {
        // Wijn 2: Voor 2+ flessen
        firstP.classList.add('tier-label', 'tier-2plus');
        card.classList.add('tier-2plus');
        badgeText = 'De Genieter+';
        badgeClass = 'badge-2plus';
        console.log(`✅ Card ${index + 1}: Genieter+`);
      } else if (tierText.includes('De Fijnproever • De Baas')) {
        // Wijn 3: Voor 3+ flessen
        firstP.classList.add('tier-label', 'tier-3plus');
        card.classList.add('tier-3plus');
        badgeText = 'De Fijnproever+';
        badgeClass = 'badge-3plus';
        console.log(`✅ Card ${index + 1}: Fijnproever+`);
      } else if (tierText.includes('Exclusief voor: De Baas')) {
        // Wijn 4-6: Alleen voor De Baas (6 flessen)
        firstP.classList.add('tier-label', 'tier-baas');
        card.classList.add('tier-baas');
        badgeText = 'De Baas Exclusief';
        badgeClass = 'badge-baas';
        console.log(`✅ Card ${index + 1}: Baas exclusief`);
      }
      
      // Note: Tier badges disabled per user request
      // Border styling is now handled via CSS classes on the card
    });
  }

  initCarousel() {
    // Try multiple selectors to find the carousel
    let carousel = document.querySelector('.wijnen-page .multicolumn .multicolumn-list');
    
    if (!carousel) {
      // Alternative selector
      carousel = document.querySelector('.wijnen-page .multicolumn-list');
    }
    
    if (!carousel) {
      console.log('🚨 Carousel not found! Tried selectors:');
      console.log('   .wijnen-page .multicolumn .multicolumn-list');
      console.log('   .wijnen-page .multicolumn-list');
      
      // Let's see what's actually there
      const multicolumns = document.querySelectorAll('.wijnen-page .multicolumn');
      console.log('🔍 Found multicolumn sections:', multicolumns.length);
      multicolumns.forEach((el, i) => {
        console.log(`   ${i}: ${el.className}`);
        const lists = el.querySelectorAll('.multicolumn-list');
        console.log(`   → multicolumn-lists: ${lists.length}`);
      });
      
      return;
    }

    console.log('🍷 Carousel found:', carousel);
    console.log('🖥️ Window width:', window.innerWidth);
    console.log('📦 Item count:', carousel.querySelectorAll('.multicolumn-list__item').length);

    // TEMP: Force desktop slider for testing
    console.log('🧪 FORCING desktop slider for testing...');
    this.enableDesktopSlider(carousel);

    // Handle window resize
    window.addEventListener('resize', () => {
      const shouldEnable = this.shouldEnableDesktopSlider(carousel);
      if (shouldEnable && !carousel.classList.contains('wine-desktop-slider')) {
        this.enableDesktopSlider(carousel);
      } else if (!shouldEnable && carousel.classList.contains('wine-desktop-slider')) {
        this.disableDesktopSlider(carousel);
      }
    });
  }

  shouldEnableDesktopSlider(carousel) {
    // Enable desktop slider if:
    // 1. Screen width >= 750px
    // 2. More than 3 items (so they don't all fit in grid)
    // 3. Not already mobile slider active
    const screenWidth = window.innerWidth;
    const itemCount = carousel.querySelectorAll('.multicolumn-list__item').length;
    const isMobileSlider = carousel.classList.contains('slider--tablet');
    
    return screenWidth >= 750 && itemCount > 3 && !isMobileSlider;
  }

  enableDesktopSlider(carousel) {
    console.log('🚀 Adding desktop slider classes...');
    
    // Add our custom desktop slider class
    carousel.classList.add('wine-desktop-slider');
    console.log('✅ Added wine-desktop-slider class');
    
    // Add native Shopify slider classes for proper behavior
    carousel.classList.add('slider');
    if (window.innerWidth >= 990) {
      carousel.classList.add('slider--desktop');
      console.log('✅ Added slider--desktop class');
    }
    
    console.log('📝 Final carousel classes:', carousel.className);

    // Add slider__slide class to all items
    const items = carousel.querySelectorAll('.multicolumn-list__item');
    items.forEach(item => {
      item.classList.add('slider__slide');
    });

    // Enable interaction
    this.addCarouselInteraction(carousel);
    
    // Scroll to start (to eliminate white space)
    carousel.scrollLeft = 0;
  }

  disableDesktopSlider(carousel) {
    // Remove our custom classes
    carousel.classList.remove('wine-desktop-slider', 'slider', 'slider--desktop');
    
    // Remove slider__slide class from items
    const items = carousel.querySelectorAll('.multicolumn-list__item');
    items.forEach(item => {
      item.classList.remove('slider__slide');
    });

    // Remove interaction
    carousel.style.cursor = '';
    carousel.removeAttribute('tabindex');
  }

  addCarouselInteraction(carousel) {
    // Set cursor style
    carousel.style.cursor = 'grab';
    
    // Mouse drag functionality
    let isScrolling = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
      isScrolling = true;
      carousel.style.cursor = 'grabbing';
      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    };

    const handleMouseLeave = () => {
      isScrolling = false;
      carousel.style.cursor = 'grab';
    };

    const handleMouseUp = () => {
      isScrolling = false;
      carousel.style.cursor = 'grab';
    };

    const handleMouseMove = (e) => {
      if (!isScrolling) return;
      e.preventDefault();
      const x = e.pageX - carousel.offsetLeft;
      const walk = (x - startX) * 2;
      carousel.scrollLeft = scrollLeft - walk;
    };

    // Keyboard navigation
    const handleKeyDown = (e) => {
      const cardWidth = window.innerWidth >= 990 ? 400 : 350;
      
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        carousel.scrollLeft -= cardWidth;
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        carousel.scrollLeft += cardWidth;
      }
    };

    // Add event listeners
    carousel.addEventListener('mousedown', handleMouseDown);
    carousel.addEventListener('mouseleave', handleMouseLeave);
    carousel.addEventListener('mouseup', handleMouseUp);
    carousel.addEventListener('mousemove', handleMouseMove);
    carousel.addEventListener('keydown', handleKeyDown);

    // Make focusable for keyboard navigation
    carousel.setAttribute('tabindex', '0');

    // Store references for potential cleanup
    carousel._carouselHandlers = {
      handleMouseDown,
      handleMouseLeave,
      handleMouseUp,
      handleMouseMove,
      handleKeyDown
    };
  }

  initAddToWinesButtons() {
    const addToWinesButtons = document.querySelectorAll('a[href^="#add-to-collection"]');
    
    addToWinesButtons.forEach(button => {
      // Update button text based on login status
      if (!this.isLoggedIn) {
        button.textContent = 'Login om toe te voegen';
        button.href = '/account/login';
        return;
      }

      // Add click handler for logged-in users
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToMyWines(button);
      });

      // Check if wine is already in collection
      this.checkWineInCollection(button);
    });
  }

  async addToMyWines(button) {
    const wineId = button.getAttribute('href').replace('#add-to-collection-', '');
    const wineCard = button.closest('.multicolumn-card');
    const wineTitle = wineCard.querySelector('h3')?.textContent || 'Unknown Wine';

    // Show loading state
    const originalText = button.textContent;
    button.textContent = 'Toevoegen...';
    button.style.opacity = '0.7';

    try {
      // Here you would normally make an API call to save to customer metafields
      // For now, we'll simulate with localStorage for demo purposes
      const myWines = JSON.parse(localStorage.getItem('myWines') || '[]');
      
      if (!myWines.find(wine => wine.id === wineId)) {
        myWines.push({
          id: wineId,
          title: wineTitle,
          month: 'Januari 2025',
          dateAdded: new Date().toISOString()
        });
        
        localStorage.setItem('myWines', JSON.stringify(myWines));
        
        // Success feedback
        button.textContent = '✓ Toegevoegd!';
        button.style.background = '#10B981';
        
        // Show success message
        this.showNotification(`${wineTitle} is toegevoegd aan jouw wijncollectie!`, 'success');
      } else {
        button.textContent = '✓ Al in collectie';
        button.style.background = '#6B7280';
      }
      
    } catch (error) {
      console.error('Error adding wine to collection:', error);
      button.textContent = 'Fout opgetreden';
      button.style.background = '#EF4444';
      
      this.showNotification('Er ging iets mis. Probeer het opnieuw.', 'error');
      
      // Reset after 3 seconds
      setTimeout(() => {
        button.textContent = originalText;
        button.style.background = '';
        button.style.opacity = '';
      }, 3000);
    }
  }

  checkWineInCollection(button) {
    const wineId = button.getAttribute('href').replace('#add-to-collection-', '');
    const myWines = JSON.parse(localStorage.getItem('myWines') || '[]');
    
    if (myWines.find(wine => wine.id === wineId)) {
      button.textContent = '✓ In Mijn Wijnen';
      button.style.background = '#6B7280';
      button.style.opacity = '0.8';
    }
  }

  showNotification(message, type = 'info') {
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `wijnen-notification wijnen-notification--${type}`;
    notification.innerHTML = `
      <div class="wijnen-notification__content">
        <span class="wijnen-notification__message">${message}</span>
        <button class="wijnen-notification__close" onclick="this.parentElement.parentElement.remove()">×</button>
      </div>
    `;

    // Add styles
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#10B981' : type === 'error' ? '#EF4444' : '#3B82F6'};
      color: white;
      padding: 16px 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 1000;
      min-width: 300px;
      animation: slideInFromRight 0.3s ease-out;
    `;

    // Add animation styles to head if not exists
    if (!document.querySelector('#wijnen-notifications-styles')) {
      const style = document.createElement('style');
      style.id = 'wijnen-notifications-styles';
      style.textContent = `
        @keyframes slideInFromRight {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        .wijnen-notification__content {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .wijnen-notification__close {
          background: none;
          border: none;
          color: white;
          font-size: 20px;
          cursor: pointer;
          margin-left: 12px;
        }
      `;
      document.head.appendChild(style);
    }

    // Add to page
    document.body.appendChild(notification);

    // Auto remove after 5 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.remove();
      }
    }, 5000);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new WijnenPage());
} else {
  new WijnenPage();
}
